export abstract class BaseModel {
    id: number;
    protected static fromJson(jsonData: any): BaseModel {
        // console.log(jsonData);
        return null;
    };
}